module.exports = __webpack_public_path__ + "static/img/3.c2c41785.png";